<template>
  <div>
    <div style="width: 100%">
      <div style="display: flex; justify-content: end">
        <a-button
          size="small"
          type="primary"
          @click="handleOpenAddModal"
        >
          <template #icon>
            <plus-outlined />
          </template>
          添加一行
        </a-button>
      </div>
      <a-table
        :dataSource="dataSource"
        :columns="columns"
        :pagination="false"
        size="small"
        :scroll="{ x: 800 }"
      >
        <template #bodyCell="{ text, column, record, index }">
          <template v-if="column.dataIndex === 'index'">
            {{ index + 1 }}
          </template>
          <template v-else-if="column.dataIndex === 'action'">
            <a-space>
              <a-button
                size="small"
                @click="handleUpdateRow(record, index)"
              >
                修改
              </a-button>
              <a-button
                size="small"
                @click="handleRemoveRow(index)"
                danger
              >
                删除
              </a-button>
            </a-space>
          </template>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, createVNode, defineComponent, reactive, ref } from 'vue';
import { ExclamationCircleOutlined, PlusOutlined } from '@ant-design/icons-vue';
import { Modal } from 'ant-design-vue';
import modalBox from 'liyu-pc-base/components/form-modal/modal-tools';

export default defineComponent({
  name: 'RemoteTable2',
  components: { PlusOutlined },
  props: {
    field: {
      type: Object,
      required: true,
    },
    modalType: {
      type: String,
      required: true,
      default: () => '',
    },
    value: {
      type: Array,
      required: true,
      default: () => [],
    },
    init_model: {
      type: Object,
      default: () => {},
    },
    watch: {
      type: Array,
      default: () => [],
    },
    formModel: {
      type: Object,
      required: true,
    },
  },
  emits: ['update:value'],
  setup(props, { emit }) {
    const columns = computed(() => {
      if (props.field.columns) {
        return props.field.columns;
      } else {
        const list = [];
        props.field?.children?.forEach(row => {
          if (row instanceof Array) {
            row.forEach(i => {
              const obj = {
                title: i.label,
                dataIndex: i.name,
                key: i.name,
                width: 150,
              };
              if (i.name2) {
                obj['dataIndex'] = i.name2;
              }
              list.push(obj);
            });
          } else {
            const obj = {
              title: row.label,
              dataIndex: row.name,
              key: row.name,
              width: 150,
            };
            if (row.name2) {
              obj['dataIndex'] = row.name2;
            }
            list.push(obj);
          }
        });
        const f = list.find(item => {
          return item.dataIndex == 'action';
        });
        if (!f) {
          const obj = {
            title: '操作',
            dataIndex: 'action',
            key: 'action',
            width: 120,
            fixed: 'right',
          };
          list.push(obj);
        }
        list.splice(0, 0, {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          width: 50,
          fixed: 'left',
        });
        return list;
      }
    });
    const dataSource = computed(() => {
      return props.value;
    });

    const handleOpenAddModal = () => {
      const rules = ref({});
      const options = {};
      const model = ref({});
      props.field.children.forEach((item: any) => {
        model.value[item.name] = null;
        if (item.name2) {
          model.value[item.name2] = null;
        }
        if (item.options) {
          options[item.name] = item.options;
        }
        if (item.required) {
          if (item.type == 'input') {
            rules.value[item.name] = [{ required: true, message: '请输入' + item.label }];
          } else if (
            ['select', 'remoteselect', 'radio', 'checkbox', 'datepicker', 'monthpicker'].includes(
              item.type,
            )
          ) {
            rules.value[item.name] = [{ required: true, message: '请选择' + item.label }];
          } else {
            rules.value[item.name] = [{ required: true, message: '请设置' + item.label }];
          }
        }
      });
      const tempModal = reactive({
        open: true,
        loading: false,
        title: props.field.label,
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'vertical',
            col: [],
          },
          fields: props.field.children,
          rules: rules,
          model: model,
        },
        options: options,
        ok: (data: any) => {
          const new_list = JSON.parse(JSON.stringify(props.value));
          new_list.push(data);
          emit('update:value', new_list);
        },
      });
      modalBox(tempModal);
    };
    const handleRemoveRow = index => {
      Modal.confirm({
        title: `是否确认删除？`,
        icon: createVNode(ExclamationCircleOutlined),
        onOk() {
          const new_list = JSON.parse(JSON.stringify(props.value));
          new_list.splice(index, 1);
          emit('update:value', new_list);
        },
        onCancel() {},
      });
    };
    const handleUpdateRow = (record, index) => {
      const rules = ref({});
      const options = {};
      const model = ref({});
      props.field.children.forEach((item: any) => {
        model.value[item.name] = record[item.name];
        if (item.name2) {
          model.value[item.name2] = null;
        }
        if (item.options) {
          options[item.name] = item.options;
        }
        if (item.required) {
          if (item.type == 'input') {
            rules.value[item.name] = [{ required: true, message: '请输入' + item.label }];
          } else if (
            ['select', 'remoteselect', 'radio', 'checkbox', 'datepicker', 'monthpicker'].includes(
              item.type,
            )
          ) {
            rules.value[item.name] = [{ required: true, message: '请选择' + item.label }];
          } else {
            rules.value[item.name] = [{ required: true, message: '请设置' + item.label }];
          }
        }
      });
      const tempModal = reactive({
        open: true,
        loading: false,
        title: props.field.label,
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'vertical',
            col: [],
          },
          fields: props.field.children,
          rules: rules,
          model: model,
        },
        options: options,
        ok: (data: any) => {
          const new_list = JSON.parse(JSON.stringify(props.value));
          const f = new_list.find((item, i) => {
            return i === index;
          });
          if (f) {
            Object.assign(f, data);
          }
          emit('update:value', new_list);
        },
      });
      modalBox(tempModal);
    };
    return {
      columns,
      dataSource,
      handleOpenAddModal,
      handleRemoveRow,
      handleUpdateRow,
    };
  },

  data() {
    return {
      model: this.value,
    };
  },
});
</script>
